import React from 'react';
import FlexBox from '../FlexBox';

import * as Styled from './styles';

/**
 * Intake Property
 */
export interface IntakePropertyProps {
  clickRemove: () => void;
  selectedProperty: any;
}

const IntakeProperty = ({
  clickRemove,
  selectedProperty,
}: IntakePropertyProps) => {
  return (
    <Styled.Box>
      <Styled.BoxRemove>
        <Styled.RemoveIcon icon={['far', 'times']} onClick={clickRemove} />
      </Styled.BoxRemove>

      <Styled.BoxTitleContainer row itemsCenter>
        <Styled.HouseIcon icon={['fas', 'house']} />

        <FlexBox>
          <Styled.BoxAddress variant="base" color="#4F4F4F">
            {selectedProperty?.address?.toLowerCase()}
          </Styled.BoxAddress>
          <Styled.BoxCity variant="sm" color="#888888">
            {selectedProperty?.city?.toLowerCase()},{' '}
            {selectedProperty?.state?.toUpperCase()} {selectedProperty?.zipCode}
          </Styled.BoxCity>
        </FlexBox>
      </Styled.BoxTitleContainer>
    </Styled.Box>
  );
};

export default IntakeProperty;
